module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_title_simple-6326bd043054dc7c401a97a78c885c96.svg";